import React, { useCallback } from 'react';
import { Button, Tooltip } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import type { HandsontableWrapperRef } from '../handsontable/HandsontableWrapperSimple';
import type { TrackedTableRef } from '../handsontable/TrackedTable';

export interface ResetFiltersButtonProps {
  tableRef: React.RefObject<HandsontableWrapperRef | TrackedTableRef | null>;
  disabled?: boolean;
}

export const ResetFiltersButton: React.FC<ResetFiltersButtonProps> = ({ tableRef, disabled = false }) => {
  const handleReset = useCallback(() => {
    const hot = tableRef?.current?.getHotInstance?.();
    if (!hot) return;
    const filtersPlugin = hot.getPlugin('filters');
    if (filtersPlugin?.isEnabled?.()) {
      filtersPlugin.clearConditions();
      filtersPlugin.filter();
    }
  }, [tableRef]);

  return (
    <Tooltip title="Сбросить фильтры" placement="bottom">
      <Button
        icon={<FilterOutlined />}
        onClick={handleReset}
        disabled={disabled}
        size="small"
        type="text"
        danger
      />
    </Tooltip>
  );
};
